import pluralize from "pluralize"

export const getAddItemsTabBadgeCopy = (lateFeeSettings, posItemsData) => {
  const hasLateFee = lateFeeSettings && lateFeeSettings.length > 0
  const hasItems = posItemsData && posItemsData.length > 0
  let badgeCopy = ""

  if (!hasLateFee && !hasItems) {
    return null
  }

  if (hasLateFee) {
    badgeCopy += "Late fee"
  }
  if (hasLateFee && hasItems) {
    badgeCopy += " & "
  }
  if (hasItems) {
    badgeCopy += `${posItemsData.length} ${pluralize(
      "Item",
      posItemsData.length
    )}`
  }

  return badgeCopy
}
